import { useState, useEffect } from 'react'
import { TextField, MenuItem, FormHelperText, Box, Typography, Grid, Link, FormControl, InputLabel, Select, FormControlLabel, Checkbox } from '@mui/material'

function BirthcareServiceSelection ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value, checked } = e.target
    onFormDataChange({ [name]: name === 'scheduleOfCharges' ? checked : value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.isNZResident.trim()) newErrors.isNZResident = 'This field is required'
    if (!formData.roomOptions.trim()) newErrors.roomOptions = 'Room options is required'
    if (!formData.scheduleOfCharges) newErrors.scheduleOfCharges = "You must agree to Birthcare's Schedule of Charges."
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Birthcare Service Selection</Typography>
      <Box sx={{ mb: 2, mt: 2 }}>
        <Typography variant='subtitle1'>
          Please refer to
          <Link href='https://birthcare.co.nz/costs/' target='_blank' rel='noopener noreferrer'> Birthcare's Schedule of Charges </Link>
          for full pricing information as you must meet certain criteria for our free services.
        </Typography>
        <FormHelperText>
          NOTE: Birthcare only provides facilities for normal labour and birth.
        </FormHelperText>
      </Box>

      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            select
            fullWidth
            label='Are you a NZ resident?'
            name='isNZResident'
            value={formData.isNZResident || ''}
            onChange={handleChange}
            variant='outlined'
            error={showErrors && !!errors.isNZResident}
            helperText={showErrors && errors.isNZResident ? errors.isNZResident : ''}
            required
          >
            <MenuItem value='true'>Yes</MenuItem>
            <MenuItem value='false'>No</MenuItem>
          </TextField>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormControl
            fullWidth
            error={showErrors && !!errors.roomOptions}
            required
          >
            <InputLabel>
              Room Options
            </InputLabel>
            <Select
              value={formData.roomOptions || ''}
              onChange={handleChange}
              label='Room Options'
              name='roomOptions'
            >
              <MenuItem value='premium'>Premium Room (if available)</MenuItem>
              <MenuItem value='private'>Private Room</MenuItem>
              <MenuItem value='shared'>Shared Room</MenuItem>
            </Select>
            {showErrors && errors.roomOptions && <FormHelperText>{errors.roomOptions}</FormHelperText>}
          </FormControl>
          <FormHelperText>
            {'Conditions apply, '}
            <Link href='https://birthcare.co.nz/costs/' target='_blank' rel='noopener noreferrer'>
              please see our schedule of charges
            </Link>
          </FormHelperText>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Additional Comments/Requirements (optional)'
            name='additionalCommentsRequirements'
            variant='outlined'
            value={formData.additionalCommentsRequirements || ''}
            onChange={handleChange}
            multiline
            rows={4}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Typography sx={{ my: 1 }} variant='h6'>Schedule of Charges</Typography>
          <FormControl required error={showErrors && !!errors.scheduleOfCharges}>
            <FormControlLabel
              control={<Checkbox
                name='scheduleOfCharges'
                checked={formData.scheduleOfCharges || false}
                onChange={handleChange}
                       />}
              label={
                <>
                  I have read and agree to the{' '}
                  <Link href='https://birthcare.co.nz/costs/' target='_blank' rel='noopener noreferrer'>
                    Birthcare Schedule of Charges
                  </Link>{' '}
                </>
                }
            />
            {showErrors && errors.scheduleOfCharges && (<FormHelperText>{errors.scheduleOfCharges}</FormHelperText>)}
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  )
}

export default BirthcareServiceSelection
